import { render, staticRenderFns } from "./VIdleModule.vue?vue&type=template&id=ab85073a&scoped=true&"
import script from "./VIdleModule.vue?vue&type=script&lang=js&"
export * from "./VIdleModule.vue?vue&type=script&lang=js&"
import style0 from "./VIdleModule.vue?vue&type=style&index=0&id=ab85073a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab85073a",
  null
  
)

export default component.exports